import { FC } from "react";
import { Link } from "react-router-dom";

import LazyLoadImage from "web/Layout/Common/LazyLoadImage";
import __ from "web/Layout/Translations";

import classes from "./image.scss";

interface IProductCardImageProps {
  className: string;
  name: string;
  image: string;
  onClick: () => void;
  to: {
    pathname: string;
    search: string;
    state: { categoryId: string; clickFrom?: string };
  };
  alt?: string;
}

const ProductCardImage: FC<IProductCardImageProps> = ({
  className,
  name,
  image,
  to,
  onClick = () => {},
  alt = "",
}) => {
  return (
    <Link
      to={to}
      className={className}
      onClick={onClick}
      aria-label={`${name} - ${__("strona produktu")}`}
    >
      <LazyLoadImage
        className={classes.image}
        src={image}
        alt={alt}
        width={400}
        height={264}
        isProduct
      />
    </Link>
  );
};

export default ProductCardImage;
